import type {
  TPayment,
  TPaymentServer,
  TPaymentsResponse,
  TPaymentserverResponse,
  TPaymentsStatsServer,
  TPaymentsStats,
} from '../../store/types';

const paymentItemAdapter = (item: TPaymentServer): TPayment => ({
  id: item.id,
  created: item.created,
  updated: item.updated,
  type: item.type,
  amount: item.amount,
  paidAmount: item.paid_amount,
  uniqueAmount: item.unique_amount,
  uniqueCurrency: item.unique_currency,
  commission: item.commission,
  partnerShopId: item.partner_shop_id,
  partnerCommissionPercent: item.partner_commission_percent === null
    ? null
    : Number(item.partner_commission_percent),
  partnerCommissionCalculationBase: item.partner_commission_calculation_base ?? null,
  partnerCommission: item.partner_commission,
  partnerCommissionCredited: item.partner_commission_credited,
  currency: item.currency,
  settlementCurrency: item.settlement_currency,
  payerId: item.payer_id,
  clientTransactionId: item.client_transaction_id,
  shopId: item.shop_id,
  methodId: item.method_id,
  methodName: item.method_name,
  methodMode: item.method_mode,
  paymentSystemName: item.payment_system_name,
  status: item.status,
  callbackStatus: item.callback_status,
  remoteCallbackStatus: item.remote_callback_status,
  remoteCallbackAmount: item.remote_callback_amount,
  remoteCallbackCurrency: item.remote_callback_currency,
  remoteCallbackReceivedAt: item.remote_callback_received_at,
  remoteId: item.remote_id,
  credentials: item.credentials,
});

export const paymentsAdapter = ({ items, count }: TPaymentserverResponse): TPaymentsResponse => ({
  count,
  items: items.map(paymentItemAdapter),
});

export const paymentStatsAdapter = (data: TPaymentsStatsServer): TPaymentsStats => ({
  totalRequests: data.total_requests,
  totalApproved: data.total_approved,
});
